import type { RequestDocument } from 'graphql-request';

export const PERSON_BY_EMAIL_QUERY: RequestDocument = `query getPersonByEmail($email: String!) {
  allPeople(filter: {email: {eq: $email}}) {
    id
    name
    email
    title
    phone
    user
    favoritePrompts
  }
}`;

export const PERSON_BY_NAME_QUERY: RequestDocument = `query getPersonByName($name: String!) {
  allPeople(filter: {name: {matches: {pattern: $name}}}) {
    id
    name
    title
  }
}`;

export const ORGS_THAT_PERSON_BELONGS_TO_QUERY = `query getPersonOrganizations($personId: ItemId!) {
  allShowcases(
    filter: {
      OR: [
        { allowList: { anyIn: [$personId] } },
        { adminList: { anyIn: [$personId] } }
      ]
    }
  ) {
    id
    title
    organization
    slug
    logo {
      url
    }
    mainImage {
      url
    }
  }
}`;

// People whose email matches a domain — used to identify Arbor's own staff,
// who are `PersonRecord`s like anyone else and are the only client-side link
// from an editor NAME (all a clip stores) back to an email address.
// Selects `name` only: the domain match is server-side, so the addresses
// themselves never need to reach a customer's browser (or our RUM captures).
export const PEOPLE_BY_EMAIL_DOMAIN_QUERY: RequestDocument = `query getPeopleByEmailDomain($pattern: String!, $first: IntType, $skip: IntType) {
  allPeople(filter: {email: {matches: {pattern: $pattern, caseSensitive: false, regexp: true}}}, first: $first, skip: $skip) {
    name
  }
}`;
